import * as actionTypes from '../actions/actionTypes';

const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

const initialState = {
    dragIndex: null,
    hoverIndex: null,
    parents: null,
    dragID: null,
    blocks: null,
    blockIDs: null,
    dndBlocks: null,
    dndBlockIDs: null,
    sectionIndex: null,
    dndSectionIndex:null,
    familyCount: null
};


const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        // LIST VIEW
        case actionTypes.LIST_VIEW_START:
            // console.log('listViewStart', action.blockIDs)
            return updateObject(state, {
                dragIndex: action.dragIndex,
                dragID: action.dragID,
                blocks: action.blocks,
                blockIDs: action.blockIDs,
                dndBlocks: action.blocks,
                dndBlockIDs: action.blockIDs,
                sectionIndex: action.sectionIndex,
                dndSectionIndex: action.sectionIndex,
                familyCount: action.familyCount
            })
        case actionTypes.LIST_VIEW_HOVER:
            // console.log('listViewHover', action.dndBlockIDs)
            return updateObject(state, {
                hoverIndex: action.hoverIndex,
                dragIndex: action.dragIndex,
                dndBlocks: action.dndBlocks,
                dndBlockIDs: action.dndBlockIDs,
                parents: action.parents
            })
        case actionTypes.LIST_VIEW_DROP:
            return updateObject(state, {})
        case actionTypes.LIST_VIEW_END:
            return updateObject(state, {})
        case actionTypes.LIST_VIEW_RESET:
            return updateObject(state, {
                dragIndex: null,
                hoverIndex: null,
                parents: null,
                dragID: null,
                blocks: null,
                blockIDs: null,
                dndBlocks: null,
                dndBlockIDs: null,
                sectionIndex: null,
                dndSectionIndex:null,
                familyCount: null
            })
        default:
            return updateObject(state)
    }
};

export default reducer;
